import { Skeleton } from "@unizpay/ui";
import type { ReactNode } from "react";

/** One headline number with a label and an optional supporting line. */
export function MetricCard({
  label,
  value,
  detail,
  loading = false,
}: {
  label: string;
  value: ReactNode;
  detail?: ReactNode;
  loading?: boolean;
}) {
  return (
    <div className="rounded-lg border border-line bg-surface px-4 py-3 shadow-xs">
      <p className="text-[0.8125rem] text-fg-muted">{label}</p>
      {loading ? (
        <>
          <Skeleton className="mt-2 h-6 w-24" />
          <Skeleton className="mt-2 h-3 w-32" />
        </>
      ) : (
        <>
          <p className="mt-1 text-xl font-semibold tracking-tight tabular-nums">{value}</p>
          {detail && <p className="mt-0.5 text-xs text-fg-muted">{detail}</p>}
        </>
      )}
    </div>
  );
}
